import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "../../api/api-client";

interface PatchRolePin {
  role_name?: string;
}

function getPatchRolePinPayload(data: PatchRolePin) {
  return {
    role_name: data.role_name,
  };
}

function useGetCategoryRoleData(category: string) {
  return useQuery({
    queryKey: ["category-roles", category],
    queryFn: () => apiClient.get(`/roles_data/${category}`).then((res) => res),
    enabled: !!category,
  });
}

export function usePatchEditUserStatus() {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      role_name: string;
      category: string;
      roleId: string;
    }) => {
      const payload = getPatchRolePinPayload(data);

      const { category, roleId } = data;
      return apiClient.patch(`/roles_name/${category}/${roleId}`, payload);
    },
    // onSuccess: (data, variables) => {
    //   const { action, userId } = variables;

    //   const statusMapping: Record<string, string> = {
    //     activate: "Active",
    //     deactivate: "Deactive",
    //   };

    //   const updatedStatus = statusMapping[action.toLowerCase()] || action;

    //   queryClient.setQueryData<any[]>(["users"], (oldUsers = []) => {
    //     const updatedUsers = oldUsers.map((user) =>
    //       user.user_id === userId ? { ...user, status: updatedStatus } : user
    //     );

    //     return updatedUsers;
    //   });
    // },
    onSuccess: () => {
      alert("Edited successfully");
    },
    onError: (error) => {
      console.error("Mutation error:", error);
      alert("Failed to edit. Please try again.");
    },
  });
}

// function getRolePayload(data: any) {
//   console.log("getRolePayloaddata", data);
//   return {
//     id: data.id || "",
//     role: data.role || "",
//     suggested_questions: data.suggested_questions || [],
//     cards: data.cards?.map((card: any) => getCardPayload(card)) || [],
//   };
// }

function getRolePayload(data: any = {}) {
  if (!data) {
    return {};
  }

  const transformedCards = (data.cards || []).map((card: any) => {
    return getCardPayload(card);
  });

  const transformedPayload = {
    id: data.id || "",
    role: data.role || "",
    suggested_questions: data.suggested_questions || [],
    cards: transformedCards,
  };

  return transformedPayload;
}

// function getCardPayload(data: any) {
//   console.log("getCardPayloaddata", data);

//   return {
//     card_id: data.card_id || "",
//     iconSrc: data.iconSrc || "",
//     title: data.title || "",
//     description: data.description || "",
//     professions_and_roles: data.professions_and_roles || {},
//     suggested_input_data: data.suggested_input_data || {},
//     prompts: data.prompts || "",
//     template: data.template || {},
//     linkText: data.linkText || "",
//     pdf: data.pdf || "",
//     suggested_attachments: data.suggested_attachments || [],
//   };
// }

function getCardPayload(data: any) {
  // console.log(
  //   "Inside getCardPayload, received data:",
  //   JSON.stringify(data, null, 2)
  // );

  if (!data) {
    return {};
  }

  const transformedCard = {
    card_id: data.card_id || "",
    iconSrc: data.iconSrc || "",
    title: data.title || "",
    description: data.description || "",
    professions_and_roles: {
      primary_users: data.primary_users || [],
      supporting_roles: data.supporting_roles || [],
    },
    suggested_input_data: {
      case_specific_details: data.case_specific_details || [],
      general_documents: data.general_documents || [],
    },
    example_files_links: [],
    prompts: data.prompts || "",
    template: data.template || {},
    linkText: data.linkText || "",
    pdf: data.pdf || "",
    suggested_attachments: data.suggested_attachments || null,
  };

  return transformedCard;
}

function useCreateCard(category: string) {
  return useMutation({
    mutationKey: ["create-card", category],
    mutationFn: (data: any) => {
      const payload = getRolePayload(data);
      return apiClient.post(`/roles_data/${category}`, payload);
    },
  });
}

function useRoleMutation() {
  return useMutation({
    mutationKey: ["roles"],
    mutationFn: async ({
      data,
      roleId,
      category,
    }: {
      data?: any;
      roleId?: string;
      category: string;
    }) => {
      if (!data.roles || data.roles.length === 0) {
        return;
      }

      if (!roleId) {
        return;
      }
      // Find the specific role matching roleId
      // const roleData = data.roles.find((role: any) => role.id === roleId);
      const roleData = data.roles.find(
        (role: any) => role.id.toLowerCase() === roleId.toLowerCase()
      );

      if (!roleData) {
        return;
      }

      const payload = getRolePayload(roleData);

      return apiClient.put(`/roles_data/${category}/${roleId}`, payload);
    },
  });
}

function useEditRole(category: string, role_id: string) {
  return useMutation({
    mutationKey: ["edit-role", category, role_id],
    mutationFn: (data) => {
      const payload = getRolePayload(data);
      return apiClient.put(`/roles_data/${category}/${role_id}`, payload);
    },
  });
}

function useEditCard(category: string, role_id: string, card_id: string) {
  return useMutation({
    mutationKey: ["edit-card", category, role_id, card_id],
    mutationFn: (data) => {
      const payload = getCardPayload(data);
      return apiClient.put(
        `/roles_data/${category}/${role_id}/cards/${card_id}`,
        payload
      );
    },
  });
}

function useEditCardMutation() {
  return useMutation({
    mutationKey: ["edit-cards"],
    mutationFn: ({
      item,
      categoryName,
      roleId,
      cardId,
    }: {
      item: any;
      categoryName: string;
      roleId: string;
      cardId: string;
    }) => {
      const payload = getCardPayload(item);
      return apiClient.put(
        `/roles_data/${categoryName}/${roleId}/cards/${cardId}`,
        payload
      );
    },
    onSuccess: () => {
      alert("Edited successfully");
    },
    onError: (error) => {
      console.error("Mutation error:", error);
      alert("Failed to edit. Please try again.");
    },
  });
}

export {
  useGetCategoryRoleData,
  useCreateCard,
  useRoleMutation,
  useEditRole,
  useEditCard,
  useEditCardMutation,
};
